var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card-item" }, [
    _c("div", { staticClass: "card-item-header" }, [
      _c("a", { attrs: { href: _vm.generatedURL } }, [
        _c("img", {
          staticClass: "thumbnail",
          attrs: { src: _vm.entity.thumbnail, lazy: "loaded" },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-item-header__icon left" }, [
        _vm.type === "collection"
          ? _c("img", {
              attrs: {
                src: "/static/creativate-icons/collection_type.svg",
                alt: "",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "embroidery"
          ? _c("img", {
              attrs: {
                src: "/static/creativate-icons/embroidery_type.svg",
                alt: "",
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "fonts"
          ? _c("img", {
              attrs: { src: "/static/creativate-icons/font_type.svg", alt: "" },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.type === "crafting"
          ? _c("img", {
              attrs: {
                src: "/static/creativate-icons/crafting_type.svg",
                alt: "",
              },
            })
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "card-item-header__icon right icon-as-button",
          on: { click: _vm.onFavoriteClick },
        },
        [
          !_vm.isFavorite
            ? _c("img", {
                attrs: {
                  src: "/static/creativate-icons/favorite.svg",
                  alt: "",
                },
              })
            : _c("img", {
                attrs: {
                  src: "/static/creativate-icons/favorited.svg",
                  alt: "",
                },
              }),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-item-body" }, [
      _c(
        "a",
        { staticClass: "entity-name", attrs: { href: _vm.generatedURL } },
        [_vm._v(_vm._s(_vm.entity.name))]
      ),
      _vm._v(" "),
      _vm.entity.isPurchased
        ? _c(
            "span",
            {
              staticClass: "card-item-body__tag card-item-body__tag--purchased",
            },
            [_vm._v(_vm._s(_vm.t("search.result.entity.purchased")))]
          )
        : _vm.entity.isFreeForAll
        ? _c(
            "span",
            { staticClass: "card-item-body__tag card-item-body__tag--free" },
            [_vm._v(_vm._s(_vm.t("search.result.entity.free")))]
          )
        : _c(
            "span",
            { staticClass: "card-item-body__tag card-item-body__tag--premium" },
            [
              _c("img", {
                attrs: {
                  src: "/static/creativate-icons/premium_tag.svg",
                  alt: "",
                },
              }),
              _vm._v(_vm._s(_vm.t("search.result.entity.premium"))),
            ]
          ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-item-footer" },
      [
        _vm.entity.designtype != "font"
          ? _c("SaveDesignVaultButton", {
              attrs: {
                designtype: _vm.entity.designtype,
                iscollection: _vm.entity.isCollection ? "true" : "false",
                designimage: _vm.entity.thumbnail || _vm.noImageUrl,
                designname: _vm.entity.label,
                sku: _vm.entity.priceGroup,
                "is-purchased": _vm.entity.isPurchased,
                "is-free-for-all": _vm.entity.isFreeForAll,
                designs: _vm.computedDesigns,
                "price-display": _vm.entity.price
                  ? _vm.entity.price.display
                  : "",
                allowedCountry: _vm.showPrice,
                designCode: _vm.entity.sku,
                nameOfDesign: _vm.entity.name,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.canDownload && _vm.entity.designtype != "font"
          ? _c("DownloadButton", {
              attrs: {
                image: _vm.entity.thumbnail || _vm.noImageUrl,
                sku: _vm.entity.sku,
                name: _vm.entity.label,
                designtype: _vm.entity.designtype,
                isCollection: _vm.entity.isCollection,
                isPurchased: _vm.entity.isPurchased,
                "is-free-for-all": _vm.entity.isFreeForAll,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        !_vm.entity.isCollection && _vm.entity.designtype != "font"
          ? _c("SendToMachineButton", {
              attrs: {
                sku: _vm.entity.sku,
                "is-purchased": _vm.entity.isPurchased,
                "is-free-for-all": _vm.entity.isFreeForAll,
                designname: _vm.entity.label,
                designimage: _vm.entity.thumbnail,
                designtype: _vm.entity.designtype,
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }